import { RefObject } from 'react';
import { marked } from 'marked';
import { ReactNode } from 'react';

import { SparkMark } from './icons';
import { IMessage } from './types';

interface Props {
	messages: IMessage[];
	isTyping: boolean;
	bodyRef: RefObject<HTMLDivElement>;
	footer?: ReactNode;
}

const ChatBotMessages = ({ messages, isTyping, bodyRef, footer }: Props) => (
	<div ref={bodyRef} className='chatBot--body'>
		{messages.map((msg) => (
			<div key={msg.id} className={`chatBot--msg-row chatBot--msg-row--${msg.role}`}>
				{msg.role === 'user' && (
					<div className='chatBot--user-bubble'>{msg.text}</div>
				)}
				{msg.role === 'ai' && (
					<div className='chatBot--ai-msg'>
						<div className='chatBot--ai-sender'>
							<SparkMark size={22} />
							<span className='chatBot--ai-name'>NovaForce</span>
							{msg.time && (
								<span className='chatBot--ai-time'>· {msg.time}</span>
							)}
						</div>
						<div
							className='chatBot--ai-text'
							dangerouslySetInnerHTML={{ __html: marked.parse(msg.text) as string }}
						/>
					</div>
				)}
			</div>
		))}

		{isTyping && (
			<div className='chatBot--ai-msg'>
				<div className='chatBot--ai-sender'>
					<SparkMark size={22} />
					<span className='chatBot--ai-name'>NovaForce</span>
				</div>
				<div className='chatBot--typing-dots'>
					<span />
					<span />
					<span />
				</div>
			</div>
		)}

		{footer}
		

	</div>
);

export default ChatBotMessages;
